module.exports = __webpack_public_path__ + "img/indifferent.d4642f0f.png";